function uploads(
    state = {
        uploading : false,
        progress : 0,
        uploadDone : false,
        upload : null,
        detail : {
            upload : null,
        }
    }, action
) {
    switch(action.type) {
        case 'UPLOAD_FILE_SELECTED' :
            return {
                ...state,
                file : action.file
            };
        case 'UPLOAD_FILE_START' :
            return {
                ...state,
                uploading : true,
                xhr : action.xhr
            };
        case 'UPLOAD_FILE_CANCEL' :
        case 'UPLOAD_CLEAR_DATA' :
            return {
                ...state,
                uploading : false,
                progress : 0,
                uploadDone : false,
                upload : null,
                file : null,
                xhr : null,
            }
        case 'UPLOAD_FILE_SUCCESS' :
            return {
                ...state,
                uploading : false,
                uploadDone : true,
                upload : action.upload,
                xhr : null,
            };
        case 'UPLOAD_FILE_FAILURE' :
            return {
                ...state,
                uploading : false,
                uploadDone : true,
                error : action.error,
                xhr : null,
            }
        case 'UPLOAD_FILE_PROGRESS' :
            return {
                ...state,
                uploading : true,
                progress : action.progress
            }
        case 'UPLOADS_FETCH_START':
        case 'UPLOADS_FETCH_SUCCESS':
        case 'UPLOADS_FETCH_FAILURE':
            return {
                ...state,
                data : uploadPaginationData(state.data, action)
            }
        case 'UPLOAD_FETCH_START':
        case 'UPLOAD_FETCH_SUCCESS':
        case 'UPLOAD_FETCH_FAILURE':
            return {
                ...state,
                detail : uploadData(state.detail, action)
            }
        case 'UPLOADMSGS_FETCH_START':
        case 'UPLOADMSGS_FETCH_SUCCESS':
        case 'UPLOADMSGS_FETCH_FAILURE':
            return {
                ...state,
                detail : {
                    ...state.detail,
                    messages : uploadMessagesData(state.detail.messages, action)    
                }
                
            }
        default :
            return state;
    }
}

function uploadPaginationData(state = {
    fetching : false,
    items : [],
}, action) {
    switch(action.type) {
        case 'UPLOADS_FETCH_START':
            return {
                ...state,
                fetching : true
            }
        case 'UPLOADS_FETCH_SUCCESS':
            return {
                ...state,
                ...action.data,
                items : action.data.data,
                fetching : false
            }
        case 'UPLOADS_FETCH_FAILURE':
            return {
                ...state,
                fetching : false,
                error : action.error
            }
        default :
            return state;
    }
}

function uploadData(state = {}, action) {
    switch(action.type) {
        case 'UPLOAD_FETCH_START':
            return {
                ...state,
                fetching : true
            }
        case 'UPLOAD_FETCH_SUCCESS':
            return {
                ...state,
                upload : action.upload,
                fetching : false
            }
        case 'UPLOAD_FETCH_FAILURE':
            return {
                ...state,
                fetching : false,
                error : action.error
            }
        default :
            return state;
    } 
}

function uploadMessagesData(state = {}, action) {
    switch(action.type) {
        case 'UPLOADMSGS_FETCH_START':
            return {
                ...state,
                fetching : true
            }
        case 'UPLOADMSGS_FETCH_SUCCESS':
            return {
                ...state,
                ...action.data,
                items : action.data.data,
                fetching : false
            }
        case 'UPLOADMSGS_FETCH_FAILURE':
            return {
                ...state,
                fetching : false,
                error : action.error
            }
        default :
            return state;
    } 
}


export default uploads;


/** WEBPACK FOOTER **
 ** ./src/reducers/uploads.js
 **/